import { render, staticRenderFns } from "./SignResult.vue?vue&type=template&id=b317296a&scoped=true&"
import script from "./SignResult.vue?vue&type=script&lang=js&"
export * from "./SignResult.vue?vue&type=script&lang=js&"
import style0 from "./SignResult.vue?vue&type=style&index=0&id=b317296a&scoped=true&lang=css&"
import style1 from "./SignResult.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317296a",
  null
  
)

export default component.exports